define('extensions/knockout.asyncComputed',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird'
], function (ko, _, Promise) {
    'use strict';

    ko.asyncComputed = function(evaluator, errorCallback, owner) {
        var result = ko.observable(),
            currentPromise;
        result.inProgress = ko.observable(false); // Track whether we're waiting for a result

        var computed = ko.computed(function() {
            // Abort any in-flight evaluation to ensure we only notify with the latest value
            if (currentPromise) {
                currentPromise.cancel();
            }

            var evaluatorResult = evaluator.call(owner);
            // Cope with both asynchronous and synchronous values
            if (evaluatorResult && (typeof evaluatorResult.done == "function")) { // Async
                evaluatorResult.cancellable();
                result.inProgress(true);
                currentPromise = evaluatorResult;
                evaluatorResult.then(function(data) {
                    result.inProgress(false);
                    result(data);
                })
                //cancellation should not change inProgress state or call errorCallback
                .catch(Promise.CancellationError, _.noop)
                .catch(function () {
                    result.inProgress(false);
                    if (errorCallback) {
                        errorCallback();
                    }
                })
                .finally(function () {
                    currentPromise = null;
                });
            } else { // Sync
                result(evaluatorResult);
            }
        });

        //Set dispose on the returned observable to dispose of the
        result.dispose = computed.dispose.bind(computed);

        return result;
    };

});

